package com.eladfinish.bible.contest.screens.search.usecases

import com.eladfinish.bible.contest.common.usecases.GetHighlightedVerseMarkupRangeUseCase
import com.eladfinish.bible.contest.common.usecases.MakeOtiotPasukSmallerUseCase
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.domain.BooksRepository.numOfChaptersPerBook
import com.eladfinish.bible.contest.domain.catalog.BibleCatalog.books
import com.eladfinish.bible.contest.utils.toOtiot

class NavigateToAdjacentChapterUseCase(
    private val getHighlightedVerseMarkupRangeUseCase: GetHighlightedVerseMarkupRangeUseCase,
    private val makeOtiotPasukSmallerUseCase: MakeOtiotPasukSmallerUseCase,
) {

    operator fun invoke(
        chapterData: ChapterData?,
        direction: ChapterDirection,
    ): ChapterData {
        val data = chapterData
            ?.takeIf { it.bookIndex != null && it.chapterIndex != null }
            ?: return ChapterData()

        val bookIndex = data.bookIndex!!
        val chapterIndex = data.chapterIndex!!

        val (bookIndexShifted, chapterIndexShifted) = when (direction) {
            ChapterDirection.Next -> when {
                bookIndex == books.lastIndex && chapterIndex == numOfChaptersPerBook[bookIndex] -> {
                    0 to 1
                }

                chapterIndex == numOfChaptersPerBook[bookIndex] -> {
                    bookIndex + 1 to 1
                }

                else -> {
                    bookIndex to chapterIndex + 1
                }
            }

            ChapterDirection.Previous -> when {
                bookIndex == 0 && chapterIndex == 1 -> {
                    books.lastIndex to numOfChaptersPerBook[books.lastIndex]
                }

                chapterIndex == 1 -> {
                    bookIndex - 1 to numOfChaptersPerBook[bookIndex - 1]
                }

                else -> {
                    bookIndex to chapterIndex - 1
                }
            }
        }

        val (onlyContent, _) = getHighlightedVerseMarkupRangeUseCase(
            bookIndex = bookIndexShifted,
            chapter = chapterIndexShifted.toOtiot(),
        )

        return ChapterData(
            bookIndex = bookIndexShifted,
            chapterIndex = chapterIndexShifted,
            content = onlyContent,
            spannedRangeList = makeOtiotPasukSmallerUseCase(charSequence = onlyContent),
        )
    }

    companion object {
        sealed class ChapterDirection {
            object Next : ChapterDirection()
            object Previous : ChapterDirection()
        }
    }
}
